import type {AppConfig} from '../initialize';
import type {IovationInboundPayload as InboundPayload} from '../../shared/IovationTypes';
import {initialize} from '../initialize';
import type {SendFn} from '../setupMessages';

const iovation = (input: InboundPayload, respond: SendFn<'Iovation'>) => {
  // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
  window['io_install_stm'] = false;
  // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
  window['io_exclude_stm'] = 12;
  // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
  window['io_install_flash'] = false;
  // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
  window['io_enable_rip'] = true;

  // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
  window['io_bb_callback'] = (blackBoxString: any, isComplete: any) => {
    if (isComplete) {
      respond({blackBoxString});
    }
  };

  const script = document.createElement('script');
  script.src = input.isProd
    ? 'https://mpsnare.iesnare.com/snare.js'
    : 'https://ci-mpsnare.iovation.com/snare.js';
  if (!document.body) {
    throw new Error('Unexpectedly missing <body>.');
  }
  document.body.appendChild(script);
};

const app = (config: AppConfig<'Iovation'>) => {
  config.subscribe((messageData, respond) => {
    iovation(messageData, respond);
  });
};

initialize({
  app,
  owner: 'risk_signals_platform',
});
